// src/pages/Dashboard/Finance/Payroll/ProcedureCurrencyChart.jsx
import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useTranslation } from "react-i18next";

const ProcedureCurrencyChart = ({ procedureData = {}, paymentData = {} }) => {
  const { t } = useTranslation();

  // Calculate the total of total_paid (USD)
  const totalPaidUSD = Array.isArray(paymentData)
    ? paymentData.reduce((sum, payment) => {
        if (payment?.display_ht_patient?.currency === 2) {
          return sum + (payment?.display_ht_patient?.total_paid || 0);
        }
        return sum;
      }, 0)
    : 0;

  // Calculate the total of total_paid (Euro)
  const totalPaidEuro = Array.isArray(paymentData)
    ? paymentData.reduce((sum, payment) => {
        if (payment?.display_ht_patient?.currency === 3) {
          return sum + (payment?.display_ht_patient?.total_paid || 0);
        }
        return sum;
      }, 0)
    : 0;

  // We only want to display revenue for USD and EUR.
  // If there is no data for these currencies, default to 0.
  const usdRevenue = Number(procedureData?.Usd?.collected_amount) || 0;
  const totalUSD = totalPaidUSD + usdRevenue;
  const eurRevenue = Number(procedureData?.Eur?.collected_amount) || 0;
  const totalEuro = totalPaidEuro + eurRevenue;

  // Prepare the data array for the chart.
  const chartData = [
    { currency: "USD", revenue: totalUSD },
    { currency: "EUR", revenue: totalEuro },
  ];

  return (
    <Paper sx={{ padding: 2, marginTop: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }} color="primary">
        {t("finance.procedureRevenueByCurrency")}
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.3} />
          <XAxis dataKey="currency" />
          <YAxis />
          <Tooltip formatter={(value) => value.toLocaleString()} />
          <Legend />
          <Bar
            dataKey="revenue"
            fill="#1976d2"
            name={t("finance.revenue")}
            barSize={50}
          />
        </BarChart>
      </ResponsiveContainer>
      <Box mt={1}>
        <Typography variant="caption" color="textSecondary">
          {t(
            "finance.usdEurChartNote",
            "This chart shows only USD and EUR procedure revenue. Afghani revenue is included in overall income."
          )}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ProcedureCurrencyChart;
